export const PWA_CHANNEL = {
    MARKETING: 'pwa_marketing',
    PRACTICE: 'pwa_practice',
};
export const TYPEAHEAD_DEBOUNCE_MS = 500;
export const TYPEAHEAD_MIN_LENGTH = 2;
